import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取合作伙伴日志列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listPartnerLog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.listPartnerLog',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取合作伙伴池列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listPartnerPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.listPartnerPool',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取合作伙伴日志参数
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getPartnerLogParam(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accessControlLog.listAccessControlLogParam',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}